<app-title-bar rootBreadCrumbs="['i18n.core.navigation.import-configuration']" titleText="i18n.core.navigation.acodis-workflow"></app-title-bar>
<div>
  <div class="row grow w-100">
    <div class="col-4 d-flex justify-content-between">
      <span>
        {{'i18n.domain.import-configuration.acodis-workflows.overview.header' | translate }}
      </span>
      <span class="e-icons icon-add e-icon-big"
        title="{{ 'i18n.domain.import-configuration.acodis-workflows.overview.add-button-tooltip' | translate }}"
        (click)="addWorkflow()">
      </span>
    </div>
  </div>
  <div class="row grow w-100">
    <div class="col-4">
      <app-acodis-workflow-overview [acodisWorkflowForm]="acodisWorkflowForm"
                                    (recordSelected)="workflowSelected($event)"
                                    (dataBoundEvent)="dataBound()">
      </app-acodis-workflow-overview>
    </div>
    <div class="col-8 h-100 right" [hidden]="workflow === null">
      <div class="e-card">
        <div class="e-card-content h-100">
          <app-acodis-workflow-form [acodisWorkflowForm]="acodisWorkflowForm"></app-acodis-workflow-form>
        </div>
        <div class="e-card-actions">
          <div class="d-flex">
            <div class="btn-group me-auto">
              @if (workflow?.id > 0 && !workflow.isInUse) {
                <button type="button" (click)="deleteWorkflow()" class="btn btn-outline-danger me-2 btn-fixedw rounded">
                  <span class="e-icons icon-erase danger me-2"></span>
                  {{ 'i18n.domain.import-configuration.acodis-workflows.buttons.delete' | translate }}
                </button>
              }
            </div>
            <div class="btn-group ms-auto">
              <button type="reset" (click)="closeWorkflow()"
                class="btn btn-outline-secondary me-2 btn-fixedw rounded">
                {{ 'i18n.domain.import-configuration.acodis-workflows.buttons.discard' | translate }}
              </button>
              <button type="submit" (click)="saveWorkflow()" class="btn btn-outline-primary me-2 btn-fixedw rounded">
                {{ 'i18n.domain.import-configuration.acodis-workflows.buttons.save' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
